<!-- Tipo de búsqueda -->
<div class="row mt-1">
    <div class="btn-group col botonera principal" role="group" aria-label="Botonera principal">
        <button class="btn btn-primary btn-sm m-0" (click)="setTipoBusqueda('sugeridos')"
                [class.active]="busquedaActual === 'sugeridos'">
            SUGERIDOS
        </button>
        <button class="btn btn-primary btn-sm m-0" (click)="setTipoBusqueda('misFrecuentes')"
                [class.active]=" busquedaActual === 'misFrecuentes'">
            MIS FRECUENTES
        </button>
        <button class="btn btn-primary btn-sm btn-block m-0" (click)="setTipoBusqueda('buscadorBasico')"
                [class.active]="busquedaActual === 'buscadorBasico'">
            BUSCADOR BÁSICO
        </button>
        <button class="btn btn-primary btn-sm btn-block m-0" (click)="setTipoBusqueda('frecuentesTP')"
                [class.active]="busquedaActual === 'frecuentesTP'">
            FRECUENTES POR PRESTACION
        </button>
    </div>
</div>
<!-- Fin Tipo de búsqueda -->

<snomed-buscar (search)="recibeResultados($event)" *ngIf="busquedaActual === 'buscadorBasico'" [autofocus]="true"
               id="buscador"></snomed-buscar>

<div class="buscador"
     *ngIf="busquedaActual === 'sugeridos' || busquedaActual === 'misFrecuentes' || busquedaActual === 'frecuentesTP'">
    <plex-text [(ngModel)]="search" name="search" (change)="buscar()" placeholder=" Buscar ..." [autoFocus]="true">
    </plex-text>
</div>

<div *ngIf="descendienteSearch && busquedaActual === 'buscadorBasico'">
    <plex-badge type="info">
        DESCENDIENTES DE {{ descendienteSearch.term.substr(0, 30) }}
        <plex-button (click)="removeDescendiente()" icon="close">
        </plex-button>
    </plex-badge>
</div>

<!-- MAESTRO DE PROBLEMAS - BD:tipoProblema -->
<!-- Botones filtros -->
<ng-container *ngIf="results">
    <div class="contenedor-filtros">
        <plex-card class="card-filtro" *ngFor="let filt of filtrosSonmed; let iPrestacion = index"
                   (click)="getCantidadResultados(filt.key) > 0 && filtroBuscadorSnomed(filt.key)">
            <div class="card-content {{filt.key}}" [ngClass]="{'active': filtroActual === filt.key}"
                 [class.disabled]="getCantidadResultados(filt.key) === 0">
                <div class="icon-wrapper">
                    <div class="contador">
                        <small *ngIf="getCantidadResultados(filt.key)">
                            {{getCantidadResultados(filt.key)}}
                        </small>
                    </div>
                    <plex-icon class="icon" name="{{filt.icono}}"></plex-icon>
                </div>
                <span class="titulo mt-1">{{filt.titulo}}</span>
            </div>
        </plex-card>
    </div>
    <div>
        <ng-container *ngIf="seccion$ | async as seccion">
            Sección: {{ seccion.term }} <br>
        </ng-container>

        <ng-container>
            <span *ngIf="ondontogramaDientes$ | async as dientes; else filtros">
                Filtros:
                <span class="text-secondary ml-1">
                    (
                    <ng-container *ngFor="let c of dientes; let idx=index; let $last=last">
                        <ng-container *ngIf="c.concepto.term">
                            <span *ngIf="c.cara">
                                diente
                            </span>
                            {{ c.concepto.term }}
                            <span *ngIf="c.cara && c.cara !== 'pieza'">
                                , cara {{ c.cara }}
                                <ng-container *ngIf="!$last">
                                    /
                                </ng-container>
                            </span>
                        </ng-container>
                    </ng-container>
                    )
                </span>
            </span>
            <ng-template #filtros>
                <ng-container *ngIf="getSemanticTagFiltros() as filtros">
                    Filtros:
                    <span class="text-secondary ml-1">
                        {{ filtros }}
                    </span>
                </ng-container>
            </ng-template>
        </ng-container>
        <ng-container
                      *ngIf="results && results[busquedaActual] && results[busquedaActual][filtroActual] && results[busquedaActual][filtroActual]?.length === 0">
            <h4 class="pt-3 pb-3 text-center">No se han encontrado resultados.</h4>

            <p class="text-center"
               *ngIf="search && (busquedaActual === 'sugeridos' || busquedaActual === 'misFrecuentes' || busquedaActual === 'frecuentesTP')">
                Intentar con el
                <a href="javascript: void(0);" (click)="setTipoBusqueda('buscadorBasico');">Buscador básico</a>
            </p>
        </ng-container>
    </div>
</ng-container>

<!-- RESULTADOS PRINCIPALES -->
<div *ngIf="filtroActual && results && results[busquedaActual][filtroActual]  && results[busquedaActual][filtroActual].length > 0"
     class="buscador-resultados">
    <cdk-virtual-scroll-viewport [itemSize]="55">
        <div *cdkVirtualFor="let item of results[busquedaActual][filtroActual]; let i = index" class="rup-card mini"
             [ngClass]="item | semanticClass: item.esSolicitud || filtroActual === 'planes'">
            <div class="rup-header">
                <div class="icon-rup drag-handle p-0 pt-1" draggable
                     [dragScope]="['registros-rup' , 'vincular-registros-rup']" [dragData]="item"
                     (onDragStart)="dragStart($event)" (onDragEnd)="dragEnd($event)">
                    <i class="adi {{ item | semanticIcon: item.esSolicitud || filtroActual === 'planes'  }}"></i>
                </div>
                <div class="rup-border">
                    <div class="row p-0 m-0 border-secondary border-left-0">
                        <div class="col-6 p-0 m-0">
                            <div class="p-0 pl-2" [ngClass]="{'actions-left': filtroActual === 'equipamientos'}">
                                <snomed-link [concepto]="item"></snomed-link>
                                <span *ngIf="item.frecuencia" class="small">
                                    ({{item.frecuencia}})
                                </span>
                                <snomed-sinonimo [concepto]="item"></snomed-sinonimo>
                            </div>
                        </div>
                        <div class="col-6 p-0 m-0">
                            <div class="d-flex justify-content-end">
                                <plex-badge size="sm"
                                            [type]="item | semanticClass: filtroActual === 'planes' || item.esSolicitud">
                                    {{ (item.esSolicitud || filtroActual === 'planes') ? 'solicitud' :
                                    item.semanticTag }}
                                </plex-badge>
                                <plex-button type="info" size="sm" icon="plus" (click)="verificarProfesional(item, i)"
                                             tooltip="agregar a la consulta" tooltipPosition="left">
                                </plex-button>
                                <plex-button class="ml-1" type="info" size="sm" icon="graph"
                                             tooltip="filtrar por descendientes" tooltipPosition="left"
                                             (click)="filtrarPorDescendientes(item)">
                                </plex-button>
                            </div>
                        </div>
                    </div>
                    <div class="row p-0 m-0">
                        <div class="col-12 p-0 m-0 ml-2">
                            <ng-container *ngIf="busquedaActual === 'sugeridos'">
                                <span *ngIf="item?.sugeridoPor" class="sugerido">
                                    <i>Sugerido por {{ item.sugeridoPor }}</i>
                                </span>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </cdk-virtual-scroll-viewport>
</div>